import {
  faEnvelope,
  faEnvelopeOpen,
  faTrash,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Badge, Typography, Space } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useNotificationDelete,
  useNotificationToggle,
} from "../../api/Notifications";
import "./NotificationItem.css";

dayjs.extend(relativeTime);

/*
	EventId: "guid",
  EventType: "string",
  Message: "string",
  NotificationId: "ulid",
  Read: boolean,
  Title: "string",
  UserId: "guid",
  Variant: "string",
  created: "iso string",
  updated: "iso string",
*/
// TODO: Add delete & mark as read action buttons
const NotificationItem = ({ notification, onClick }) => {
  const {
    Title,
    Message,
    created,
    Read,
    UserId,
    NotificationId,
    EventType,
    EventId,
  } = notification;

  const [read, setRead] = useState(Read);
  const [deleted, setDeleted] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const navigate = useNavigate();
  const notificationToggle = useNotificationToggle(UserId, NotificationId);
  const notificationDelete = useNotificationDelete(NotificationId);

  const handleDelete = async () => {
    setDisabled(true);
    notificationDelete
      .mutateAsync()
      .then(() => {
        setDeleted(true);
      })
      .finally(() => setDisabled(false));
  };

  const handleAction = async () => {
    notificationToggle
      .mutateAsync(true)
      .then(() => onClick && onClick())
      .finally(() => {
        navigateNotification();
      });
  };

  const handleRead = async () => {
    setDisabled(true);
    notificationToggle
      .mutateAsync(!read)
      .then(() => {
        setRead(!read);
      })
      .finally(() => setDisabled(false));
  };

  const navigateNotification = () => {
    switch (EventType) {
      case "session":
        navigate(`/sessions/${EventId}`);
        break;
    }
  };

  return deleted ? null : (
    <div
      className={`notification-item ${Read && "read"}`}
      // onClick={() => notificationClick()}
    >
      <Badge dot={!read} color="purple">
        <Space direction="vertical">
          <div>
            <div className="notification-item-header">
              <Typography.Title level={5}>{Title}</Typography.Title>
            </div>
            <div className="notification-item-body">{Message}</div>
            <div className="notification-item-footer">
              {dayjs(created).fromNow()}
            </div>
          </div>
          <Space
            direction="horizontal"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button
              onClick={() => handleAction()}
              size="small"
              type="primary"
              disabled={disabled}
            >
              View
            </Button>
            <div>
              <Button
                size="small"
                type="text"
                onClick={() => handleRead()}
                disabled={disabled}
              >
                <FontAwesomeIcon icon={read ? faEnvelopeOpen : faEnvelope} />
              </Button>
              <Button
                size="small"
                type="text"
                onClick={() => handleDelete()}
                disabled={disabled}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </div>
          </Space>
        </Space>
      </Badge>
    </div>
  );
};

export default NotificationItem;
